<template>
  <div id="app">
    <div class="wrapper">
      <a class="skiplink" href="#content">
        <span class="skiplink__text">Ga direct naar inhoud</span>
      </a>
      <header class="header "
              role="banner">
        <div class="header-logo">
          <a href="/" title="Logo Dienst Uitvoering Onderwijs"><span class="screenreader-only">dienst uitvoering onderwijs, naar de homepage</span></a>
        </div>
      </header>
      <nav class="top-nav top-nav--simple top-nav--hemelblauw" id="docs-nav">
        <div class="container">
          <div class="breadcrumbs hidden-md-down">
            <ul class="breadcrumbs__list">
              <li>
                <a :href="labels.NAV_HOME_URL" title="Home">
                  <i class="icon icon-home" role="presentation"></i>
                  <span>{{ labels.NAV_HOME }}</span>
                </a>
              </li>
              <li>
                  <span>{{ labels.NAV_ONDERWERP }}</span>
              </li>
            </ul>
          </div>
          <div class="navigation-mobile hidden-lg-up">
            <a :href="labels.NAV_HOME_URL" class="navigation-mobile__button top-nav__block-item">
              <svg class="icon icon--svg" id="icon-home" viewBox="0 0 32 32" preserveAspectRatio="xMinYMin" width="100%" height="100%">
                <path fill-rule="evenodd" d="M25.74 15.438l-9.471-8.34a.423.423 0 0 0-.54 0l-9.469 8.34a.745.745 0 0 0-.26.57v.56c0 .22.179.39.4.39H8v8.04h6V19h4v5.997h6v-8.04h1.599c.222 0 .401-.17.401-.39v-.56c0-.22-.09-.42-.26-.57"></path>
              </svg>
              <span>{{ labels.NAV_HOME }}</span>
            </a>
            <a class="navigation-mobile__button top-nav__block-item" href="/particulier/footer/service/inloggen-op-mijn-duo.jsp&#10;" role="button" tabindex="0">
              <svg class="icon icon--svg" role="presentation" focusable="false"><use xlink:href="#icon-lock"></use></svg>
              <span>Login</span>
            </a>
          </div>
          <div class="top-nav__block top-nav__block--right hidden-md-down">
            <a href="https://duo.nl/particulier/inloggen/">
              <svg class="icon icon--svg" id="icon-lock" viewBox="0 0 32 32" preserveAspectRatio="xMinYMin" width="100%" height="100%">
                <path d="M17 21.252v2.373h-1.5v-2.373a1.568 1.568 0 0 1-.825-1.377 1.575 1.575 0 1 1 3.15 0c0 .597-.336 1.11-.825 1.377zm-4.875-8.127A4.13 4.13 0 0 1 16.25 9a4.13 4.13 0 0 1 4.125 4.125v1.758c.653.126 1.694.33 1.775.355.12.039.102.117.094.137H12.125v-2.25zm11.625 2.25h-.375v-2.25A7.133 7.133 0 0 0 16.25 6a7.133 7.133 0 0 0-7.125 7.125v1.758c.653.126 1.694.33 1.775.355.12.039.102.117.094.137H8.75a.75.75 0 0 0-.75.75v9.13a.75.75 0 0 0 .621.739c1.196.212 4.023.631 7.629.631s6.433-.419 7.629-.631a.75.75 0 0 0 .621-.739v-9.13a.75.75 0 0 0-.75-.75z"></path>
              </svg>
              <span>Log in</span>
            </a>
          </div>
        </div>
      </nav>
      <main class="skiplink-target main" id="content" tabindex="-1">
        <div id="nav">
          <router-view />
        </div>
      </main>
      <footer class="footer">
        <div class="footer__content background--hemelblauw">
          <div class="container">
            <div class="row">
              <div class="col-sm-12 col-md-10 col-md-offset-1">
              {{labels.FOOTERTEKST}}
              </div>
            </div>
          </div>
        </div>
      </footer>

    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "app",
  computed: {
    ...mapGetters(["labels"])
  },
  created() {
  }
};
</script>
